import React from 'react';

import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import HandshakeIcon from '@mui/icons-material/Handshake';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import GroupIcon from '@mui/icons-material/Group';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import PersonIcon from '@mui/icons-material/Person';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import SchoolIcon from '@mui/icons-material/School';
import DateRangeIcon from '@mui/icons-material/DateRange';
import CalculateIcon from '@mui/icons-material/Calculate';
import DashboardIcon from '@mui/icons-material/Dashboard';
import RadarIcon from '@mui/icons-material/Radar';
import ViewInArIcon from '@mui/icons-material/ViewInAr';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import AssessmentIcon from '@mui/icons-material/Assessment';
import PercentIcon from '@mui/icons-material/Percent';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import MonitorIcon from '@mui/icons-material/Monitor';
import SvgIcon from '@mui/material/SvgIcon';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import MailIcon from '@mui/icons-material/Mail';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';

export function getIconComponent(
  iconName: string,
  isDarkMode: boolean,
  locationPath: string,
) {
  switch (iconName) {
    case 'PeopleAltIcon':
      return <PeopleAltIcon />;
    case 'HandshakeIcon':
      return <HandshakeIcon />;
    case 'ShowChartIcon':
      return <ShowChartIcon />;
    case 'GroupIcon':
      return <GroupIcon />;
    case 'CloudDownloadIcon':
      return <CloudDownloadIcon />;
    case 'AssignmentIndIcon':
      return <AssignmentIndIcon />;
    case 'AccountCircleIcon':
      return <AccountCircleIcon />;
    case 'PersonIcon':
      return <PersonIcon />;
    case 'TrackChangesIcon':
      return <TrackChangesIcon />;
    case 'SchoolIcon':
      return <SchoolIcon />;
    case 'DateRangeIcon':
      return <DateRangeIcon />;
    case 'CalculateIcon':
      return <CalculateIcon />;
    case 'DashboardIcon':
      return <DashboardIcon />;
    case 'RadarIcon':
      return <RadarIcon />;
    case 'ViewInArIcon':
      return <ViewInArIcon />;
    case 'MonetizationOnIcon':
      return <MonetizationOnIcon />;
    case 'AssessmentIcon':
      return <AssessmentIcon />;
    case 'PercentIcon':
      return <PercentIcon />;
    case 'FactCheckIcon':
      return <FactCheckIcon />;
    case 'CreditCard':
      return <CreditCardIcon />;
    case 'AccessTimeFilledIcon':
      return <AccessTimeFilledIcon />;
    case 'MonitorIcon':
      return <MonitorIcon />;
    case 'MailIcon':
      return <MailIcon />;
    case 'AssignmentTurnedInIcon':
      return <AssignmentTurnedInIcon />;
    case 'AccountBalanceWalletIcon':
      return <AccountBalanceWalletIcon />;
    case 'ReceiptLongIcon':
      return <ReceiptLongIcon />;
    case 'ClientAreaIcon':
      return (
        <SvgIcon viewBox="0 0 260 260">
          <path d="M218,94h3.023C228.057,108.874,232,125.484,232,143c0,63.411-51.589,115-115,115S2,206.411,2,143S53.589,28,117,28 c17.516,0,34.126,3.943,49,10.977V42v9.574l-7.979,7.979C145.64,53.441,131.715,50,117,50c-51.28,0-93,41.72-93,93s41.72,93,93,93 s93-41.72,93-93c0-14.716-3.441-28.641-9.552-41.022L208.426,94H218z M164,143c0,25.916-21.084,47-47,47s-47-21.084-47-47 s21.084-47,47-47c1.472,0,2.926,0.077,4.363,0.21l18.351-18.351C132.596,75.37,124.957,74,117,74c-38.047,0-69,30.953-69,69 s30.953,69,69,69s69-30.953,69-69c0-7.957-1.37-15.596-3.859-22.714l-18.35,18.35C163.923,140.074,164,141.528,164,143z M218,74 l40-40h-32V2l-40,40v17.857l-61.425,61.425c-2.373-0.828-4.92-1.283-7.575-1.283c-12.703,0-23,10.297-23,23 c0,12.703,10.297,23,23,23c12.703,0,23-10.297,23-23c0-2.655-0.455-5.202-1.283-7.575L200.143,74H218z" fill="currentColor"/>
        </SvgIcon>
      );
    case 'TraderAreaIcon':
      return (
        <SvgIcon viewBox="0 0 400 400">
          <path d="M50 50V316.667C50 325.507 53.5119 333.986 59.7631 340.237C66.0143 346.488 74.4928 350 83.3333 350H350M316.667 150L233.333 233.333L166.667 166.667L116.667 216.667" stroke="currentColor" strokeWidth="33.4167" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
        </SvgIcon>
      );
    case 'FundedAreaIcon':
      return (
        <SvgIcon viewBox="0 0 49 49" sx={{ fontSize: '1.3rem' }}>
          <path d="M17.1457 7.34829V17.1459M17.1457 31.8424V36.7413M36.741 2.44946V7.34829M36.741 26.9436V34.2918M2.44922 2.44946V41.6401C2.44922 42.9393 2.96534 44.1854 3.88405 45.1041C4.80276 46.0228 6.0488 46.5389 7.34805 46.5389H46.5387M14.6963 17.1459H19.5951C20.9479 17.1459 22.0445 18.2426 22.0445 19.5954V29.393C22.0445 30.7458 20.9479 31.8424 19.5951 31.8424H14.6963C13.3435 31.8424 12.2469 30.7458 12.2469 29.393V19.5954C12.2469 18.2426 13.3435 17.1459 14.6963 17.1459ZM34.2916 7.34829H39.1904C40.5432 7.34829 41.6398 8.44493 41.6398 9.7977V24.4942C41.6398 25.847 40.5432 26.9436 39.1904 26.9436H34.2916C32.9388 26.9436 31.8422 25.847 31.8422 24.4942V9.7977C31.8422 8.44493 32.9388 7.34829 34.2916 7.34829Z" stroke="currentColor" strokeWidth="4.89883" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
        </SvgIcon>
      );
    case 'PartnerAreaIcon':
      return (
        <SvgIcon viewBox="0 0 54 49" sx={{ fontSize: '1.3rem' }}>
          <path d="M36.741 46.5389V41.6401C36.741 39.0416 35.7088 36.5495 33.8713 34.7121C32.0339 32.8747 29.5419 31.8424 26.9434 31.8424H12.2469C9.64837 31.8424 7.1563 32.8747 5.31889 34.7121C3.48147 36.5495 2.44922 39.0416 2.44922 41.6401V46.5389M36.741 2.76299C38.842 3.30766 40.7027 4.53456 42.031 6.25111C43.3592 7.96765 44.0799 10.0767 44.0799 12.2471C44.0799 14.4176 43.3592 16.5266 42.031 18.2431C40.7027 19.9597 38.842 21.1866 36.741 21.7312M51.4375 46.5389V41.6401C51.4359 39.4692 50.7133 37.3604 49.3833 35.6447C48.0533 33.929 46.1912 32.7036 44.0893 32.1609M29.3928 12.2471C29.3928 17.6582 25.0062 22.0448 19.5951 22.0448C14.184 22.0448 9.79746 17.6582 9.79746 12.2471C9.79746 6.83602 14.184 2.44946 19.5951 2.44946C25.0062 2.44946 29.3928 6.83602 29.3928 12.2471Z" stroke="currentColor" strokeWidth="4.89883" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
        </SvgIcon>
      );
    case 'DownloadIcon':
      return (
        <SvgIcon viewBox="0 0 49 49" sx={{ fontSize: '1.3rem' }}>
          <path d="M24.4939 31.8424V2.44946M24.4939 31.8424L12.2469 19.5954M24.4939 31.8424L36.741 19.5954M46.5387 31.8424V41.6401C46.5387 42.9393 46.0225 44.1854 45.1038 45.1041C44.1851 46.0228 42.9391 46.5389 41.6398 46.5389H7.34805C6.0488 46.5389 4.80276 46.0228 3.88405 45.1041C2.96534 44.1854 2.44922 42.9393 2.44922 41.6401V31.8424" stroke="currentColor" strokeWidth="4.89883" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
        </SvgIcon>
      );
    case 'CertificateIcon':
      return <SchoolIcon />;
    case 'EconomicCalendarIcon':
      return (
        <SvgIcon viewBox="0 0 49 54" sx={{ fontSize: '1.3rem' }}>
          <path d="M14.6963 2.44946V12.2471M34.2916 2.44946V12.2471M2.44922 22.0448H46.5387M7.34805 7.34829H41.6398C44.3454 7.34829 46.5387 9.54157 46.5387 12.2471V46.5389C46.5387 49.2445 44.3454 51.4377 41.6398 51.4377H7.34805C4.6425 51.4377 2.44922 49.2445 2.44922 46.5389V12.2471C2.44922 9.54157 4.6425 7.34829 7.34805 7.34829Z" stroke="currentColor" strokeWidth="4.89883" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
        </SvgIcon>
      );
    case 'RaiseFXIcon':
      return (
        <SvgIcon viewBox="0 0 489 482">
          <path d="M414.069 276.182L284.085 422.621L369.721 351.318L459.946 393.487L414.069 276.182Z" fill="currentColor"/>
          <path d="M311.448 96.6029L120.928 139.855L224.479 99.2423L231.227 0L311.448 96.6029Z" fill="currentColor"/>
          <path d="M488.8 101.725L0 210.852L229.689 264.881L190.238 280.929L166.855 481.532L488.8 101.725Z" fill="currentColor"/>
        </SvgIcon>
      );
    default:
      return null;
  }
}
